module.exports = __webpack_public_path__ + "img/jk_bg.45878beb.png";